export const STRIPE_PRODUCTION = "PRODUCTION";
